/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreamingPlatform } from './StreamingPlatform';
import {
    StreamingPlatformFromJSON,
    StreamingPlatformFromJSONTyped,
    StreamingPlatformToJSON,
    StreamingPlatformToJSONTyped,
} from './StreamingPlatform';

/**
 * 
 * @export
 * @interface AddFeaturedStreamBody
 */
export interface AddFeaturedStreamBody {
    /**
     * Display label for the stream
     * @type {string}
     * @memberof AddFeaturedStreamBody
     */
    label: string;
    /**
     * 
     * @type {StreamingPlatform}
     * @memberof AddFeaturedStreamBody
     */
    platform: StreamingPlatform;
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedStreamBody
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedStreamBody
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedStreamBody
     */
    youtubeChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedStreamBody
     */
    youtubeLiveId?: string;
    /**
     * Sort priority (lower = higher priority)
     * @type {number}
     * @memberof AddFeaturedStreamBody
     */
    priority?: number;
}



/**
 * Check if a given object implements the AddFeaturedStreamBody interface.
 */
export function instanceOfAddFeaturedStreamBody(value: object): value is AddFeaturedStreamBody {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function AddFeaturedStreamBodyFromJSON(json: any): AddFeaturedStreamBody {
    return AddFeaturedStreamBodyFromJSONTyped(json, false);
}

export function AddFeaturedStreamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFeaturedStreamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'platform': StreamingPlatformFromJSON(json['platform']),
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
        'youtubeLiveId': json['youtubeLiveId'] == null ? undefined : json['youtubeLiveId'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function AddFeaturedStreamBodyToJSON(json: any): AddFeaturedStreamBody {
    return AddFeaturedStreamBodyToJSONTyped(json, false);
}

export function AddFeaturedStreamBodyToJSONTyped(value?: AddFeaturedStreamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'platform': StreamingPlatformToJSON(value['platform']),
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
        'youtubeLiveId': value['youtubeLiveId'],
        'priority': value['priority'],
    };
}

